import { CategoryThreeItem } from '@/shared/api/endpoints/menu';

import { DiscountFilter } from '../../api/productList';

export function renderFilterLabels(filters: string[]): string {
  return `${filters.slice(0, 3).join('; ')}${
    filters.length > 3 ? ` (+${filters.length - 3})` : ''
  }`;
}

export function renderDiscountFilterLabels(
  filters: string[],
  discountFilter: DiscountFilter
): string {
  return `${filters
    .slice(0, 3)
    .map(
      (filter) =>
        discountFilter.values.find((value) => value.key === filter)?.value ?? ''
    )
    .join('; ')}${filters.length > 3 ? ` (+${filters.length - 3})` : ''}`;
}

export function renderPriceFilterLabels(
  filters: string[],
  currency: string
): string {
  return `${Number(filters[0].split(' ')[0])} ${currency} - ${Number(
    filters[1].split(' ')[0]
  )} ${currency}`;
}

export function renderPilePriceFilterLabels(
  filters: string[],
  currency: string
): string {
  return `${Number(filters[0]) / 100} ${currency} - ${Number(filters[1]) / 100} ${currency}`;
}

export const findCategory =
  (value: string, slug: boolean) =>
  ([head, ...tail]: CategoryThreeItem[]): CategoryThreeItem | undefined => {
    if (head === undefined) return undefined;

    if (slug) {
      if (head.slug === value || head.slug_temporary === value) return head;
    } else {
      if (head.category_id === value) return head;
    }

    if (head.children) {
      const childrenResult = findCategory(value, slug)(head.children);
      if (childrenResult) return childrenResult;
    }

    return findCategory(value, slug)(tail);
  };

export function listCategoriesBySlug(
  slug: string,
  categoryThree: CategoryThreeItem[]
) {
  const currentCategory = findCategory(slug, true)(categoryThree);

  const parentCategory = currentCategory
    ? findCategory(currentCategory.parent_id, false)(categoryThree)
    : undefined;

  let listCategories: CategoryThreeItem[];
  if (currentCategory) {
    listCategories =
      currentCategory?.children || parentCategory?.children || [];
  } else {
    listCategories = categoryThree;
  }

  return { listCategories, currentCategory, parentCategory };
}
